export const MOVE_ASSOCIATE = 'MOVE_ASSOCIATE';

export const UPDATE_CLOCKED_IN_STATUS = 'UPDATE_CLOCKED_IN_STATUS';

export const SET_MODEL = 'SET_MODEL';

export const RESET_MODEL = 'RESET_MODEL';

export const RESOURCE_STATUS_ENRICHMENT = 'RESOURCE_STATUS_ENRICHMENT';
